import React, { useState, useEffect, Fragment, useContext } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../Utils/AppContext";
import styled from "styled-components";
import { useGetAllFleets, deleteFleet } from "../Utils/Fleet";
import Table from "../Base/Table";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
var moment = require("moment");

const Input = styled.input`
  padding: 10px;
  font-size: 14px;
  margin-bottom: 10px;
  width: 305px;
  padding: 12px 20px;
`;

/**
 * Fleet Table Component
 */
const FleetTable = ({ companyId, uid, title, limit, data, hideFilter, hideCompany, hideDelete }) => {
  const context = useContext(AppContext);
  const currentAdminUser = context.state.user;

  const [filter, setFilter] = useState("");

  // List of Users
  const { loading: loadingFleets, fleets } = useGetAllFleets(companyId, uid);

  var fleetCols = [
    {
      Header: "Name",
      accessor: "name",
      headerClassName: "left",
      minWidth: 200,
      Cell: props => {
        // eslint-disable-next-line react/prop-types
        const { original } = props;
        var cid = companyId ? companyId : original.cid;
        return (
          <Link
            to={
              currentAdminUser.role === "super"
                ? `/${cid}/fleet/${original.fid}`
                : {
                    pathname: `/fleet/${original.fid}`,
                    state: {
                      cid
                    }
                  }
            }
          >
            {original.name}
          </Link>
        );
      }
    }
  ];

  if (!hideCompany)
    fleetCols.push({
      Header: "Company",
      className: "left",
      headerClassName: "left",
      accessor: "companyName"
    });

  fleetCols.push(
    {
      Header: "Drivers",
      accessor: "drivers",
      className: "center",
      Cell: props => {
        // eslint-disable-next-line react/prop-types
        const { original } = props;
        if (original.drivers !== null) {
          return original.drivers.length;
        }
        return 0;
      }
    },
    {
      Header: "Avg. Energy",
      accessor: "averageEnergyLevel",
      className: "center"
    },
    {
      id: "created",
      Header: "Created",
      headerClassName: "left",
      accessor: d => {
        return d.created ? moment(d.created).format("MM/DD/YYYY") : "";
      }
    }
  );

  if (!hideDelete)
    fleetCols.push({
      Header: "",
      className: "center",
      sortable: false,
      Cell: props => {
        // eslint-disable-next-line react/prop-types
        const { original } = props;
        return (
          <button
            type="button"
            onClick={() => {
              confirmAlert({
                title: "Confirm Deletion",
                message: "Are you sure you want to delete this fleet?",
                buttons: [
                  {
                    label: "Yes",
                    onClick: () => deleteFleet(original.cid, original.fid)
                  },
                  {
                    label: "No"
                  }
                ]
              });
            }}
          >
            Delete
          </button>
        );
      }
    });

  const tableData = data ? data : fleets;
  const filteredData = filter ? tableData.filter(d => d.name.toLowerCase().includes(filter.toLowerCase())) : tableData;

  return (
    <Fragment>
      {title && <h2>{title}</h2>}
      {!hideFilter && (
        <form>
          <Input
            type="text"
            name="filter"
            id="filter"
            placeholder="Filter by Name"
            onChange={event => {
              setFilter(event.target.value);
            }}
            value={filter}
          />
        </form>
      )}
      <Table data={filteredData} columns={fleetCols} pageSize={filteredData.length} />
    </Fragment>
  );
};

export default FleetTable;
